import Swiper from 'swiper/bundle';

export class ProductSpot {
    #options;
    #refs;
    constructor(element) {
        this.#refs = {
            el:element
        }
        this.swiperItems = [...element.querySelectorAll('.product-deck__item')];
        this.#options = { ...this.settings };
        this.init();
    }

    init() {
        this.#getCustomOptions();
        this.#runSwiperSlide();
    }

    #getCustomOptions() {
        this.#options['slidesPerView'] = this.#refs.el.dataset?.slidesPerView || this.#options['slidesPerView'];
        this.#options['mobileViewport'] = this.#refs.el.dataset?.mobileViewport || this.#options['mobileViewport'];
        if(this.#refs.el.dataset?.loop ) {
            this.#options['loop'] = JSON.parse(this.#refs.el.dataset?.loop);
        }
    }

    get #viewportWidth() {
        return Math.max(
          document.body.scrollWidth,
          document.documentElement.scrollWidth,
          document.body.offsetWidth,
          document.documentElement.offsetWidth,
          document.documentElement.clientWidth
        );
    }

    get #checkIfSwiperShouldInitialize() {
        // If mobile viewport
        if(this.#options['mobileViewport'] > this.#viewportWidth) return true;
        // If items are less or equal slidesPerView
        if(this.swiperItems.length <= this.#options['slidesPerView']) return false;
        return true;
    }

    #runSwiperSlide() {
        if(!this.#checkIfSwiperShouldInitialize) return;
        this.#refs.el.classList.remove('disabled_swiper');
        new Swiper(this.#refs.el, this.#options);
    }

    get settings() {
        return {
            speed: 600,
            spaceBetween: 30,
            loop: true,
            loopFillGroupWithBlank: false,
            slidesPerView: 5,
            mobileViewport: 769,
            navigation: {
                nextEl: this.#refs.el.querySelector('.button-next'),
                prevEl: this.#refs.el.querySelector('.button-prev')
            },
            keyboard: {
                enabled: true,
            },
            breakpoints: {
                "320": {
                    slidesPerView: 1
                },
                "500": {
                    slidesPerView: 2
                },
                "680": {
                    slidesPerView: 3
                },
                "1000": {
                    slidesPerView: 4
                },
                "1280": {
                    slidesPerView: 5
                }
            }
        }
    }
}